import { useEffect, useRef, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { copyText } from '@/lib/clipboard';

/**
 * Copy affordance that turns into the same "Saved ✓" pill used by EditorDiskBar
 * for ~2s — only after the clipboard write actually resolved.
 */
export function CopyButton({ text, label = 'Copy' }: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => clearTimeout(timer.current), []);

  if (copied) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium bg-muted text-muted-foreground transition-[opacity,scale] duration-(--duration-popover) ease-out starting:scale-95 starting:opacity-0 motion-reduce:starting:scale-100">
        <Check className="h-3.5 w-3.5" aria-hidden />
        Copied
      </span>
    );
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={async () => {
        if (!(await copyText(text))) return;
        setCopied(true);
        timer.current = setTimeout(() => setCopied(false), 2000);
      }}
    >
      <Copy className="h-3.5 w-3.5" aria-hidden />
      {label}
    </Button>
  );
}
